module.exports = __webpack_public_path__ + "img/fi-rr-square-root.42c36e2d.svg";